import { ReactNode, createContext, useContext } from 'react';

type GoogleMapsContextType = {
  apiKey: string;
  getStreetViewUrl: (address: string) => string;
  getStaticMapUrl: (address: string) => string;
};

const GoogleMapsContext = createContext<GoogleMapsContextType | undefined>(
  undefined
);

const GoogleMapsProvider: React.FC<{ children: ReactNode; apiKey: string }> = ({
  children,
  apiKey,
}) => {
  const getStreetViewUrl = (address: string) =>
    `https://maps.googleapis.com/maps/api/streetview?size=600x300&location=${address}&key=${apiKey}`;

  const getStaticMapUrl = (address: string) =>
    `https://maps.googleapis.com/maps/api/staticmap?center=${address}&zoom=15&size=600x300&maptype=roadmap&markers=color:red%7Clabel:A%7C${address}&key=${apiKey}`;

  return (
    <GoogleMapsContext.Provider
      value={{ apiKey, getStreetViewUrl, getStaticMapUrl }}
    >
      {children}
    </GoogleMapsContext.Provider>
  );
};

const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};

export { GoogleMapsProvider, useGoogleMaps };
